import React, { useEffect, useRef } from 'react';
import {IProps} from './types';
import * as S from './styles';

const ClickOutside:React.FC<IProps> = (props) => { 
    const componentRef = useRef<HTMLDivElement>(null);

    const handleClickOuside = (e: any)=> {
        if(componentRef && componentRef.current){
            const ref = componentRef.current
            if(!ref.contains(e.target) && e.pointerType!="mouse"){
                props.onClickOutside();
            }
        }
    }

    useEffect(() => {
        document.addEventListener(props.event ?? "click", handleClickOuside);
        return () => document.removeEventListener(props.event ?? "click", handleClickOuside);
    }, [props.refresh]);

    return (
            <S.Root ref={componentRef} style={props.style}>
                {props.children} 
            </S.Root>
    );
}

export default ClickOutside;